import { hydrate } from 'svelte'
import createStakeholdersStores from '../stores/createStakeholdersStores'

// import Leaderboard from '../../components/UC-leaderboard.svelte'
import StakeholdersLeaderboard from '../../components/StakeholdersLeaderboard.svelte'

/**
 * Fetch data for Stakeholders page; mount its components
 */
export async function buildStakeholders() {
  const [
    data, // the main store; will hold ALL data fetched
    loading, // will be true until the data fetching is done, can be used in components for loading state
    error, // if the fetches went completely sideways, this will be truthy, and can be used in components
    
    stakeholdersLeaderboardStore,
  ] = await createStakeholdersStores()

  const stakeholdersDOM = document.getElementById('stakeholders-leaderboard')


  if(stakeholdersDOM) {

    hydrate(StakeholdersLeaderboard, {
      target: stakeholdersDOM,
      props: {
        title: 'College Academic Ranking',
        showAllSchools: true,
        dataStore: stakeholdersLeaderboardStore,
        loadingStore: loading,
      }
    })
  }
}